export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list.vue?vue&type=template&id=7d5f5e73&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/agents/list.vue?vue&type=template&id=7d5f5e73&scoped=true
// module id = Y3cE
// module chunks = 0